<template>
  <div class="setting">
    <v-img
        class="white--text align-end wallpaper"
        :height="$vuetify.breakpoint.xs ? 250 : 350"
        :src="seller.wallpaper ? $HOST_URL + seller.wallpaper : ''"
    ></v-img>
    <div class="pa-4 d-flex align-center">
      <v-avatar size="80" class="mr-4">
        <v-img :src="seller.usericon ? $HOST_URL + seller.usericon : ''"/>
      </v-avatar>
      <div class="overflow-hidden pr-4">
        <div class="text-ellipsis headline">{{ seller.nickname }}</div>
        <div class="body-2 self-intro">{{ seller.self_intro }}</div>
      </div>
      <v-spacer></v-spacer>
      <div class="other-info">
        <div>{{ seller.followers }}</div>
        <div>粉絲</div>
      </div>
      <div class="other-info">
        <div>{{ seller.follows }}</div>
        <div>追蹤中</div>
      </div>
    </div>
    <v-btn block tile depressed dark color="pink" @click="$refs.editProfile.dialog = true">修改個人資料</v-btn>
    <div class="type">商品</div>
    <div class="body">
      <v-btn block large>
        開啟通知
        <v-switch v-model="notification" color="pink" disabled></v-switch>
      </v-btn>
      <v-btn block large to="/portal/blocks">
        封鎖用戶
        <v-icon>chevron_right</v-icon>
      </v-btn>
      <v-btn block large @click="$refs.changePassword.open('seller')">
        重置密碼
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </div>
    <div class="type">聊天</div>
    <div class="body">
      <v-btn block large @click="chat_price_dialog = true">
        訊息桃子數
        <div class="pink--text">
          <div class="peach"></div>{{ seller.chat_price }}
        </div>
      </v-btn>
      <v-btn block large to="/portal/blocks">
        違規
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </div>
    <div class="type">桃子</div>
    <div class="body">
      <v-btn block large to="profit">
        收益明細
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </div>
    <div class="type">驗證</div>
    <div class="body">
      <v-btn block large>
        身分驗證
        <v-icon>chevron_right</v-icon>
      </v-btn>
      <v-btn block large>
        信箱驗證
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </div>
    <div class="type">資訊</div>
    <div class="body">
      <v-btn block large>
        常見問題
        <v-icon>chevron_right</v-icon>
      </v-btn>
      <v-btn block large @click="$refs.aboutus.dialog = true">
        聯繫客服
        <v-icon>chevron_right</v-icon>
      </v-btn>
      <v-btn block large to="/policy">
        隱私權政策
        <v-icon>chevron_right</v-icon>
      </v-btn>
      <v-btn block large to="/terms">
        服務條款
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </div>
    <v-btn block tile dark color="red" class="mt-10" @click="logout">登出</v-btn>

    <AboutUs ref="aboutus"></AboutUs>
    <ChangePassword ref="changePassword"></ChangePassword>
    <EditProfile ref="editProfile"></EditProfile>
    <v-dialog
      v-model="chat_price_dialog"
      max-width="500px"
    >
      <v-card class="px-12 py-8">
        <span class="body-2">
          <div class="peach"></div>
          訊息桃子數
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="ml-2 mb-2" v-bind="attrs" v-on="on">fa-question-circle</v-icon>
            </template>
            <span>需等於 0 或在 400 至 4000 之間</span>
          </v-tooltip>
        </span>
        <v-text-field 
          outlined 
          dense 
          :rules="[rules.chat_price]" 
          v-model="chat_price"
          autofocus
          @keydown.enter="saveChatPrice"
        ></v-text-field>
        <v-btn color="pink" dark block @click="saveChatPrice">確定</v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AboutUs from '@/components/AboutUs'
import ChangePassword from '@/components/ChangePassword'
import EditProfile from '@/components/portal/EditProfile'
export default {
  data() {
    return {
      notification: true,
      chat_price_dialog: false,
      chat_price: 0,
      rules: {
        chat_price: price => price === 0 || (price >= 400 && price <= 4000)
      }
    }
  },
  components: { AboutUs, ChangePassword, EditProfile },
  computed: {
    ...mapState('seller', ['seller'])
  },
  watch: {
    chat_price_dialog(newValue) {
      this.chat_price = this.seller.chat_price
    }
  },
  methods: {
    logout() {
      this.axios.post('/portal/logout').then(response => {
        this.$store.dispatch('seller/logout')
        this.$router.push('/login?type=seller')
      })
    },
    saveChatPrice() {
      console.log(this.chat_price)
      this.axios.put(`/portal/me`, {
        chat_price: this.chat_price
      }).then(response => {
        this.$root.$emit('alert', 'success', '更新成功')
        this.$store.dispatch('seller/getSellerInformation')
        this.chat_price_dialog = false
      }).catch(() => {
        this.$root.$emit('alert', 'error', '更新失敗')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.setting {
  .self-intro {
    line-height: 18px;
    max-height: 36px;
    overflow: hidden;
    word-break: break-all;
    white-space: pre-line;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    font-size: 14px;
    color: grey;
  }
  .other-info {
    display: flex;
    flex-direction: column;
    margin: 0 20px;
    font-size: 14px;
    align-items: center;
    line-height: 24px;
    @include mobile {
      margin: 0 10px;
    }
    div {
      white-space: nowrap;
    }
  }
  .type {
    margin: 24px 12px 6px;
    color: $grey-1;
    font-size: 14px;
  }
  .body {
    .v-btn {
      text-transform: none;
      font-weight: 400;
      color: $grey-4 !important;
      font-size: 16px;
      background: white !important;
      margin-bottom: 2px;
      box-shadow: none;
      .v-btn__content {
        display: flex;
        justify-content: space-between;
        span {
          color: lightgrey;
        }
      }
    }
  }
}
</style>